import React from "react";
import { LegalPage } from "./legal/LegalPage";

const ContratoPF = () => <LegalPage namespace="legalContratoPF" />;

export default ContratoPF;
